<script setup>

const props = defineProps({
  size: {
    type: String,
    default: '2rem'
  }
})

const sizeProp = computed(() => props.size)
</script>
<template>
  <div class="flex justify-center">
    <Icon name="svg-spinners:ring-resize" :size="sizeProp"/>
  </div>
</template>